module.exports = __webpack_public_path__ + "static/media/0015.5b367303.jpg";